import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTwitter,
  faFacebook,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import {
  faPhoneSquare,
  faEnvelope,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { faCopyright } from "@fortawesome/free-regular-svg-icons";
import { NavLink } from "react-router-dom";
import RFQModal from "./RFQModal";
import Logo from "../assets/img/outcess-logo.png";

const Footer = ({ variant }) => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

  const currentYear = new Date().getFullYear();

  return (
    <div id="footer" className={variant === "us" ? "us-footer" : ""}>
      <RFQModal show={show} setShow={setShow} />
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-grid-up">
            {variant === "us" && (
              <div className="footer-details footer-brand">
                <img src={Logo} alt="Outcess" className="footer-logo" />
              </div>
            )}
            <div className="footer-details">
              <p>COMPANY</p>
              <ul>
                <li>
                  <NavLink to="/about" activeClassName="active-link" exact>
                    About Us
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/business-partners"
                    activeClassName="active-link"
                    exact>
                    Business Partners
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/ideology" activeClassName="active-link" exact>
                    Ideology
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/isoqualitystatement"
                    activeClassName="active-link"
                    exact>
                    ISO Quality Statement
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/ismspolicystatement"
                    activeClassName="active-link"
                    exact>
                    ISMS Policy Statement
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/outcess-clients"
                    activeClassName="active-link"
                    exact>
                    Clients
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/careers" activeClassName="active-link" exact>
                    Careers
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/data-policy"
                    activeClassName="active-link"
                    exact>
                    Privacy Policy
                  </NavLink>
                </li>
              </ul>
            </div>
            <div className="footer-details">
              <p>SERVICES</p>
              <ul>
                <li>
                  <NavLink
                    to="/business-process-outsourcing"
                    activeClassName="active-link"
                    exact>
                    Business Process Outsourcing
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/business-productivity-solutions"
                    activeClassName="active-link"
                    exact>
                    Business Productivity Solutions
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/cloud-solutions"
                    activeClassName="active-link"
                    exact>
                    Cloud Solutions
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/customer-engagement-Solutions"
                    activeClassName="active-link"
                    exact>
                    Customer Engagement Solutions
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/omni-channel-marketing"
                    activeClassName="active-link"
                    exact>
                    Omni-Channel Digital Marketing
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/aml-solutions"
                    activeClassName="active-link"
                    exact>
                    Anti-Money Laundering (AML) Solutions
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/clm-solutions"
                    activeClassName="active-link"
                    exact>
                    Customer Lifecycle Management (CLM) Solutions
                  </NavLink>
                </li>
              </ul>
            </div>
            <div className="footer-details">
              <p>SUPPORT</p>
              <ul>
                <li>
                  <a href="/contact-us">Contact Us</a>
                </li>
                <li>
                  <NavLink to="/grievance" activeClassName="active-link" exact>
                    Submit a Grievance
                  </NavLink>
                </li>
                <li>
                  <a href="https://outcess-microsite.blogspot.com/">Blog</a>
                </li>
                <li>
                  <a href="https://outcess-solutions-nigeria-ltd.dmc-microsite.com/">
                    Microsite
                  </a>
                </li>
                <li>
                  <NavLink to="/faqs" activeClassName="active-link" exact>
                    FAQ
                  </NavLink>
                </li>
              </ul>
            </div>
            {variant === "us" ? (
              <div className="footer-details">
                <ul>
                  <li>
                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                    <a
                      href="https://www.google.com/maps/place/Suite+125,+321+Ballenger+Centre+Drive,+Frederick,+MD+21703,+USA/@39.3923007,-77.4258492,17z/data=!3m1!4b1!4m5!3m4!1s0x89c9db7d6e7e5a61:0x8b3f7dbe1b6d2f69!8m2!3d39.3923007!4d-77.4236605"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suite 125, 321 Ballenger Centre Drive, Frederick, MD 21703, USA
                    </a>
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faEnvelope} />
                    <a href="mailto:info@outcess.com">info@outcess.com</a>
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faPhoneSquare} />
                    <a href="tel:02013300308">02013300308</a>
                  </li>
                </ul>
              </div>
            ) : (
              <div className="footer-details">
                <ul>
                  <li>
                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                    <a
                      href="https://www.google.com/maps/place/75+Opebi+Rd,+Opebi+101233,+Ikeja/@6.5881754,3.3602254,17z/data=!3m1!4b1!4m5!3m4!1s0x103b926a76c393a9:0xeb56c08a8639c34a!8m2!3d6.5881754!4d3.3624141"
                      target="_blank"
                      rel="noreferrer"
                    >
                      75 Opebi Road, Ikeja, Lagos State
                    </a>
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                    <a
                      href="https://www.google.com/maps/place/Suite+125,+321+Ballenger+Centre+Drive,+Frederick,+MD+21703,+USA/@39.3923007,-77.4258492,17z/data=!3m1!4b1!4m5!3m4!1s0x89c9db7d6e7e5a61:0x8b3f7dbe1b6d2f69!8m2!3d39.3923007!4d-77.4236605"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suite 125, 321 Ballenger Centre Drive, Frederick, MD 21703, USA
                    </a>
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faEnvelope} />
                    <a href="mailto:info@outcess.com">info@outcess.com</a>
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faPhoneSquare} />
                    <a href="tel:02013300308">02013300308</a>
                  </li>
                </ul>
              </div>
            )}
          </div>
          <div className="footer-media">
            <p>
              <FontAwesomeIcon icon={faCopyright} /> {currentYear} Outcess. All
              Rights Reserved
            </p>
            <ul>
              <li>
                <a
                  href="https://twitter.com/outcesspowered"
                  target="_blank"
                  rel="noreferrer">
                  <FontAwesomeIcon icon={faTwitter} />
                </a>
              </li>
              <li>
                <a
                  href="https://facebook.com/outcessng"
                  target="_blank"
                  rel="noreferrer">
                  <FontAwesomeIcon icon={faFacebook} />
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/outcess_ng"
                  target="_blank"
                  rel="noreferrer">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              </li>
              <li>
                <a
                  href="http://linkedin.com/company/outcess/"
                  target="_blank"
                  rel="noreferrer">
                  <FontAwesomeIcon icon={faLinkedin} />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
